export enum OrganizationFormGroupName {
  Details = 'details',
  AdminUser = 'adminUser',
  MasterOfRoles = 'masterOfRoles',
}
